import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { NotificationInline } from '../../Notification'
import { QA_NAME_GRETA_AI_CHAT_SOURCE_REVOKED } from '../GretaAIChat.constants'

import * as styles from './GretaAIChatSourceRevokedNotice.module.css'

function GretaAIChatSourceRevokedNotice() {
  const { t } = useTranslation()

  return (
    <NotificationInline
      className={styles.notice}
      qaName={QA_NAME_GRETA_AI_CHAT_SOURCE_REVOKED}
      text={t('Greta.FinanceRevokedNoticeKey')}
      type={NOTIFICATION_TYPE.info}
    />
  )
}

export default GretaAIChatSourceRevokedNotice
